import React              from 'react';
import { useTranslation } from 'react-i18next';
import TextField          from '@material-ui/core/TextField';
import PropTypes          from 'prop-types';

const ShellPortProtocolSelector = ({ value, setValue, disabled = false, required = false, ...rest }) => {
	const { t } = useTranslation();

	return (
		<TextField
			label={t('tablecell_shell_port_protocol')}
			helperText={t('tablecell_shell_port_protocol_helper')}
			value={value}
			onChange={e => setValue(e.target.value)}
			select
			fullWidth
			InputLabelProps={{ shrink: !!value }}
			disabled={disabled}
			required={required}
			variant='outlined'
			SelectProps={{
				native: true
			}}
			{...rest}
		>
			<option value='tcp'>{t('shell_port_protocol_tcp')}</option>
			<option value='udp'>{t('shell_port_protocol_udp')}</option>
			<option value='both'>{t('shell_port_protocol_both')}</option>
		</TextField>
	);
};

export default ShellPortProtocolSelector;

ShellPortProtocolSelector.propTypes = {
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	setValue: PropTypes.func.isRequired,
	value: PropTypes.string
};
